import { useCallback, useMemo, useState } from 'react';
import { Video } from '../types/Video';
import {
  VideoViewerModalContext,
  type VideoViewerModalOptions,
} from './VideoViewerModalContext';
import VideoViewerModal from './VideoViewerModal';

interface VideoViewerModalProviderProps {
  children: React.ReactNode;
}

const VideoViewerModalProvider: React.FC<VideoViewerModalProviderProps> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [video, setVideo] = useState<Video | null>(null);
  const [startSecond, setStartSecond] = useState<number | undefined>();
  const [studySetId, setStudySetId] = useState<string | undefined>();

  const open = useCallback((v: Video, options?: VideoViewerModalOptions) => {
    setVideo(v);
    setStartSecond(options?.startSecond);
    setStudySetId(options?.studySetId);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = useMemo(() => ({ open, close }), [open, close]);

  return (
    <VideoViewerModalContext.Provider value={value}>
      {children}
      <VideoViewerModal
        open={isOpen}
        video={video}
        startSecond={startSecond}
        studySetId={studySetId}
        onClose={() => setIsOpen(false)}
        onVideoUpdated={(updatedVideo) => {
          setVideo(updatedVideo);
        }}
      />
    </VideoViewerModalContext.Provider>
  );
};

export default VideoViewerModalProvider;
